module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_003.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_003.png
// module id = 2319
// module chunks = 5